module.exports = __webpack_public_path__ + "static/img/contextual-recruitment-aus-one-year-on.efdda6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/contextual-recruitment-aus-one-year-on.png
// module id = /R8y
// module chunks = 0